import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const TyreSizeCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-tyre-size-calculator" />;

export default TyreSizeCalculatorGuidePage;
